import { createTheme, ThemeOptions } from '@mui/material';
import { coastThemeOptions } from '@vayufp/coast-components';

import { divider, menuItem } from './components';
import { palette } from './palette';

const { spacing, shadows, typography, components } = coastThemeOptions;

const themeOptions: ThemeOptions = {
  spacing,
  shadows,
  palette,
  typography,

  components: {
    ...components,
    MuiDivider: divider,
    MuiMenuItem: menuItem,
  },
};

const theme = createTheme(themeOptions);

export { themeOptions };
export default theme;
